(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/youtube-video.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/youtube-video.js');

'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _React = React,
  useState = _React.useState;
var Icon = svs.ui.ReactIcon;
var YoutubeVideo = function YoutubeVideo(_ref) {
  var videoId = _ref.videoId,
    src = _ref.src,
    heightPercent = _ref.heightPercent,
    height = _ref.height,
    width = _ref.width,
    title = _ref.title,
    thumbnailUrl = _ref.thumbnailUrl,
    fitWrapper = _ref.fitWrapper;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    renderIframe = _useState2[0],
    setRenderIframe = _useState2[1];
  var renderYoutubePlayer = function renderYoutubePlayer() {
    setRenderIframe(true);
  };
  return React.createElement("div", {
    className: "js-youtube-video-container youtube-video-container react-yt-video ".concat(fitWrapper ? 'youtube-video-container-fit' : ''),
    "data-video-id": videoId,
    itemProp: "video",
    itemScope: true,
    itemType: "http://schema.org/VideoObject",
    style: heightPercent ? {
      paddingBottom: "".concat(heightPercent, "%")
    } : null
  }, renderIframe && React.createElement("iframe", {
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    alt: title,
    className: "js-youtube-video-iframe js-youtube-video-".concat(videoId, " youtube-video-iframe"),
    height: height,
    src: "".concat(src, "&autoplay=1"),
    title: title,
    width: width
  }), !renderIframe && React.createElement("div", {
    className: "youtube-video-player js-youtube-video-player",
    onClick: renderYoutubePlayer
  }, React.createElement("picture", {
    className: "youtube-video-thumbnail-wrapper"
  }, React.createElement("source", {
    media: "(min-width: 1280px)",
    srcSet: "".concat(thumbnailUrl, "/maxresdefault.jpg")
  }), React.createElement("source", {
    media: "(min-width: 640px)",
    srcSet: "".concat(thumbnailUrl, "/sddefault.jpg")
  }), React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: "".concat(thumbnailUrl, "/hqdefault.jpg")
  }), React.createElement("source", {
    media: "(min-width: 320px)",
    srcSet: "".concat(thumbnailUrl, "/mqdefault.jpg")
  }), React.createElement("img", {
    className: "youtube-video-thumbnail",
    height: height,
    src: "".concat(thumbnailUrl, "/default.jpg"),
    title: title,
    width: width
  })), React.createElement("div", {
    className: "youtube-video-icon"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "play",
    size: "800"
  }))));
};
svs.components.youtube_video.YoutubeVideo = YoutubeVideo;

 })(window);